import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appMuFilterToolbarField]',
})
export class MuFilterToolbarFieldDirective {
  @Input('appMuFilterToolbarField') name: string;

  constructor(public template: TemplateRef<any>) {
    /** */
  }
}
